<template>
  <div :class="pageCls">
    <div class="d1"></div>
    <div :class="bgmRun==1? 'd2 d2ruan' : 'd2'" @click="bgmRunClick">
      <div class="b1"></div>
      <div class="b2"></div>
      <div class="b3"></div>
      <div class="b4"></div>
      <div class="b5"></div>
    </div>
    <div class="d3"></div>
    <div class="d4"></div>
    <div class="d5"></div>
    <div class="d6"></div>
    <div class="d7"></div>
    <div class="d8" @click="btnClick"></div>
    <div class="d9"><span>{{chiNum/10}}<i>m</i></span></div>
    <div class="d10"></div>
    <div class="d11"></div>
  </div>
</template>

<script>
export default {
  name: 'Page1',
  props: {
    msg: String
  },
  data(){
    return{
      chiNum:0,
      pageCls:"page1",
      bgmRun:1
    }
  },
  mounted(){
    setTimeout(() => {
      this.chiNumAdd();
    }, 1100);
  },
  methods:{
    chiNumAdd(){
      let that = this;
      let chiNumAddTem;
      chiNumAddFun();
      function chiNumAddFun(){
        that.chiNum += 3;
        if(that.chiNum > 52){
          that.chiNum=52
        }
        // that.chiNum = that.chiNum.toFixed(1);
        // console.log(that.chiNum)
        if(that.chiNum >= 52){
          clearTimeout(chiNumAddTem);
        }else{
          setTimeout(() => {
            chiNumAddFun();
          }, 30);
        }
      }
    },
    btnClick(){
      if(document.getElementById('music').length>0){
        document.getElementById('music').play();
      }
      this.pageCls = "page1 page1_2";
      setTimeout(() => {
        this.$emit('setPage',2);
      }, 2200);
    },
    bgmRunClick(){
      if(this.bgmRun==1){
        this.bgmRun=2
        if(window.netease.ua.android){
          this.$emit('pauseSond',"bgm");
        }
        if(window.netease.ua.ios){
          document.getElementById('music').pause();
        }
      }else{
        this.bgmRun=1
        if(window.netease.ua.android){
          this.$emit('playSond',"bgm");
        }
        if(window.netease.ua.ios){
          document.getElementById('music').play();
        }
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$time:0.75;
.page1{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  .d1{
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height: 1.22rem;
    background: url(../assets/bg05.png) no-repeat 0 0 / 100% 100%;
    z-index: 10;
  }
  .d2,.d2ruan{
    position: absolute;
    right:0.25rem;
    top:1.45rem;
    width: 0.71rem;
    height: 0.72rem;
    background: url(../assets/bg06.png) no-repeat 0 0 / 100% 100%;
  }
  .d2ruan{
    background: none;
    .b1{
      position: absolute;
      right:0;
      top:0;
      width: 0.16rem;
      height: 100%;
      background: url(../assets/bg06.png) no-repeat 100% 0 / auto 100%;
    }
    .b2{
      position: absolute;
      right:0.23rem;
      top:0;
      width: 0.08rem;
      height: 100%;
      background: url(../assets/bg06.png) no-repeat -0.4rem 0 / auto 100%;
      opacity: 0;
      animation:1.5s linear infinite d2Ani1;
    }
    .b3{
      position: absolute;
      left:0.25rem;
      top:0;
      width: 0.07rem;
      height: 100%;
      background: url(../assets/bg06.png) no-repeat -0.25rem 0 / auto 100%;
      opacity: 0;
      animation:1.5s linear infinite d2Ani2;
    }
    .b4{
      position: absolute;
      left:0.12rem;
      top:0;
      width: 0.07rem;
      height: 100%;
      background: url(../assets/bg06.png) no-repeat -0.12rem 0 / auto 100%;
      opacity: 0;
      animation:1.5s linear infinite d2Ani3;
    }
    .b5{
      position: absolute;
      left:0;
      top:0;
      width: 0.07rem;
      height: 100%;
      background: url(../assets/bg06.png) no-repeat 0 0 / auto 100%;
      opacity: 0;
      animation:1.5s linear infinite d2Ani4;
    }
  }
  .d3{
    position: absolute;
    right:0.15rem;
    top:50%;
    width: 0.91rem;
    height: 1.38rem;
    margin:1.15rem 0 0 0;
    background: url(../assets/bg08.png) no-repeat 0 0 / 100% 100%;
  }
  .d4{
    position: absolute;
    left:0;
    top:50%;
    width: 7.38rem;
    height: 5.8rem;
    margin:0.25rem 0 0 0;
    background: url(../assets/bg12.png) no-repeat 0 0 / 100% 100%;
  }
  .d5{
    position: absolute;
    right:0;
    top:50%;
    width: 2.37rem;
    height: 4.57rem;
    margin:-3.82rem 0 0 0;
    background: url(../assets/bg11.png) no-repeat 0 0 / 100% 100%;
  }
  .d6::before{
    content: '';
    position: absolute;
    right:0.26rem;
    top:50%;
    width: 1.32rem;
    height: 1.32rem;
    margin:-4.8rem 0 0 0;
    background: url(../assets/bg09.png) no-repeat 0 0 / 100% 100%;
    transform: scale(0.8);
    animation:1s linear infinite transformAni;
  }
  .d6::after{
    content: '';
    position: absolute;
    right:0;
    top:50%;
    width: 0.85rem;
    height: 0.85rem;
    margin:-4rem 0 0 0;
    background: url(../assets/bg09.png) no-repeat 0 0 / 100% 100%;
    transform: scale(1.2);
    animation:1s linear infinite transformAni;
  }
  .d7{
    position: absolute;
    left:0;
    top:50%;
    width: 4.83rem;
    height: 7.27rem;
    margin:-7.27rem 0 0 0;
    background: url(../assets/bg07.png) no-repeat 0 0 / 100% 100%;
    transform: translateY(-7.27rem);
    animation:1s linear 1 transformAni2;
    animation-fill-mode: forwards;
    z-index: 9;
  }
  .d8{
    position: absolute;
    right:0.25rem;
    top:50%;
    width: 3.36rem;
    height: 2.27rem;
    margin:3.65rem 0 0 0;
    background: url(../assets/bg13.png) no-repeat 0 0 / 100% 100%;
    &:hover,&:active{
      transform: scale(1.05);
    }
    &:visited,&:link{
      transform: scale(1);
    }
  }
  .d8::before{
    content: '';
    position: absolute;
    left:0.26rem;
    top:-0.32rem;
    width: 3.54rem;
    height: 2.28rem;
    background: url(../assets/bg17.png) no-repeat 0 0 / 100% 100%;
    transform: rotate(-5deg);
    animation:3s linear infinite transformAni;
  }
  .d8::after{
    content: '';
    position: absolute;
    left:-0.1rem;
    top:-0.42rem;
    width: 3.83rem;
    height: 2.55rem;
    background: url(../assets/bg10.png) no-repeat 0 0 / 100% 100%;
    transform: rotate(5deg);
    animation:3s linear infinite transformAni;
  }
  .d9{
    position: absolute;
    left:0;
    top:50%;
    width: 3.32rem;
    height: 5.92rem;
    margin:-0.8rem 0 0 0;
    background: url(../assets/bg14.png) no-repeat 0 0 / 100% 100%;
    z-index: 8;
    span{
      position: absolute;
      left:1.22rem;
      top:2.94rem;
      width: 1.2rem;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: left;
      color:#fff;
      font-weight: bold;
      font-size:0.4rem;
      transform: rotate(-30deg) skew(-30deg);
    }
  }
  .d10{
    position: absolute;
    left:1.1rem;
    top:50%;
    width: 5.6rem;
    height: 4.22rem;
    margin:-0.7rem 0 0 0;
    background: url(../assets/bg15.png) no-repeat 0 0 / 100% 100%;
    transform:translate(-2rem,1rem);
    animation:0.7s 1s linear 1 transformAni2;
    animation-fill-mode: forwards;
  }
  .d11{
    position: absolute;
    left:50%;
    top:50%;
    width: 6.43rem;
    height: 5.43rem;
    margin:-2.75rem 0 0 1.24rem;
    background: url(../assets/bg16.png) no-repeat 0 0 / 100% 100%;
    transform:translate(-2rem,1rem);
    animation:0.7s 1s linear 1 transformAni2;
    animation-fill-mode: forwards;
  }
}
.page1_2{
  .d11{
    transform:translate(0);
    animation:0.5s linear 1 opacityAni;
    animation-fill-mode: forwards;
  }
  .d10{
    transform:translate(0);
    animation:1s 0.3s linear 1 d10Ani;
    animation-fill-mode: forwards;
  }
  .d7,.d8,.d9{
    transform:translate(0);
    animation:0.5s 0.8s linear 1 opacityAni;
    animation-fill-mode: forwards;
  }
  .d5{
    animation:1s 1.5s linear 1 d5Ani;
    animation-fill-mode: forwards;
    transform-origin: 90% 50%;
  }
}
@keyframes d2Ani1 {
  0%{
    opacity: 0;
  }
  25%{
    opacity: 1;
  }
  100%{
    opacity: 1;
  }
}
@keyframes d2Ani2 {
  25%{
    opacity: 0;
  }
  50%{
    opacity: 1;
  }
  100%{
    opacity: 1;
  }
}
@keyframes d2Ani3 {
  50%{
    opacity: 0;
  }
  75%{
    opacity: 1;
  }
  100%{
    opacity: 1;
  }
}
@keyframes d2Ani4 {
  75%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
@keyframes d5Ani {
  20%{
    z-index: 11;
  }
  100%{
    z-index: 11;
    transform:scale(10);
  }
}
@keyframes d10Ani {
  50%{
      transform:translate(-2rem,1rem);
      opacity: 1;
  }
  100%{
    transform:translate(-2rem,1rem);
    opacity: 0;
  }
}
</style>
